import SuperFetch from '../../superFetch.js';
import SuperFetchV2 from '../../superFetchV2';

class OrderApi {
  /**
   *  [주문 전체 리스트] 주문 전체 리스트 요청하기
   */
  getOrderAllList = (data) => SuperFetch.post('/order/all/list', data);

  /**
   *  [주문 전체 리스트] 주문 전 리스트 엑셀 다운로드
   */
  getOrderAllListExcelDownload = (data) => SuperFetch.post('/order/all/list/excel/download', data);

  /**
   *  [주문 취소 리스트] 주문 취소 리스트 요청하기
   */
  getOrderCancelList = (data) => SuperFetch.post('/order/cancel/list', data);

  /**
   *  [주문 취소 리스트] 주문 취소 리스트 엑셀 다운로드
   */
  getOrderCancelListExcelDownload = (data) => SuperFetch.post('/order/cancel/list/excel/download', data);

  /**
   *  [주문 반품 리스트] 주문 반품 리스트 요청하기
   */
  getOrderReturnList = (data) => SuperFetch.post('/order/return/list', data);

  /**
   *  [주문 반품 리스트] 주문 반품 리스트 엑셀 다운로드
   */
  getOrderReturnListExcelDownload = (data) => SuperFetch.post('/order/return/list/excel/download', data);

  /**
   *  [주문 교환 리스트] 주문 교환 리스트 요청하기
   */
  getOrderExchangeList = (data) => SuperFetch.post('/order/exchange/list', data);

  /**
   *  [주문 교환 리스트] 주문 교환 리스트 엑셀 다운로드
   */
  getOrderExchangeListExcelDownload = (data) => SuperFetch.post('/order/exchange/list/excel/download', data);

  /**
   *  [주문/배송관리] 주문/배송관리 리스트 요청하기
   */
  getOrderManagementList = (data) => SuperFetch.post('/order/management/list', data);

  /**
   *  [주문/배송관리] 상품 주문 상품 준비 처리하기
   */
  deliveryPreparation = (data) => SuperFetch.post('/order/management/list/update/delivery/preparation', data);

  /**
   *  [주문/배송관리] 상품 주문 배송 지연처리하기
   */
  deliveryDelay = (data) => SuperFetch.post('/order/management/list/update/delivery/delay', data);

  /**
   *  [주문/배송관리] 상품 주문 발송 처리전 유효성 체크하기
   */
  checkDeliveryDispatch = (data) => SuperFetch.post('/order/management/list/update/delivery/dispatch/check', data);

  /**
   *  [주문/배송관리] 상품 주문 엑셀 일괄 발송 처리전 유효성 체크하기
   */
  checkExcelBulkDeliveryDispatch = (data) =>
    SuperFetch.post('/order/management/list/update/delivery/dispatch/bulk/check', data);

  /**
   *  [주문/배송관리] 상품 주문 발송 처리하기
   */
  deliveryDispatch = (data) => SuperFetch.post('/order/management/list/update/delivery/dispatch', data);

  /**
   *  [주문/배송관리] 판매 취소 전 재고, 상품상태 설정 리스트 가져오기
   */
  getCancelOrderManagementInfoList = (data) => SuperFetch.post('/order/management/list/update/cancel/confirm', data);

  /**
   *  [주문/배송관리] 판매 취소하기
   */
  cancelSales = (data) => SuperFetch.post('/order/management/list/update/cancel', data);

  /**
   *  [주문/배송관리] 주문자 정보 수정하기
   */
  editBuyerInfo = (data) => SuperFetch.post('/order/management/list/update/delivery/recipient', data);

  /**
   *  [주문/배송관리] 송장 수정하기
   */
  editDeliveryInfo = (data) => SuperFetch.post('/order/management/list/update/delivery/info', data);

  /**
   *  [주문/배송관리] 전체 엑셀 다운로드
   */
  getAllManagementListExcelDownLoad = (data) => SuperFetch.post('/order/management/list/excel/download', data);

  /**
   *  [주문/배송관리] 선택 엑셀 다운로드
   */
  getSelectedManagementListExcelDownLoad = (data) =>
    SuperFetch.post('/order/management/list/excel/download/selected', data);

  /**
   *  [주문/배송관리] 전체 엑셀 다운로드(브랜드별 분할)
   */
  getAllManagementListExcelSplitDownLoad = (data) =>
    SuperFetch.post('/order/management/list/excel/split/download', data);

  /**
   *  [주문/배송관리] 선택 엑셀 다운로드(브랜드별 분할)
   */
  getSelectedManagementListExcelSplitDownLoad = (data) =>
    SuperFetch.post('/order/management/list/excel/split/download/selected', data);

  /**
   *  [취소 관리] 취소 관리 리스트 요청하기
   */
  getOrderCancelManagementList = (data) => SuperFetch.post('/order/cancel/management/list', data);

  /**
   *  [취소 관리] 취소 관리 전체 리스트 엑셀 다운로드 요청하기
   */
  getOrderCancelManagementAllListExcelDownload = (data) =>
    SuperFetch.post('/order/cancel/management/list/excel/download', data);

  /**
   *  [취소 관리] 취소 관리 선택 리스트 엑셀 다운로드 요청하기
   */
  getOrderCancelManagementSelectedListExcelDownload = (data) =>
    SuperFetch.post('/order/cancel/management/list/excel/download/selected', data);

  /**
   *  [취소 관리] 취소 거부 요청하기
   */
  rejectOrderCancel = (data) => SuperFetch.post('/order/cancel/management/list/update/reject', data);

  /**
   *  [취소 관리] 취소 완료 요청 전 상품 또는 옵션의 재고, 상태 설정 리스트 요청하기
   */
  getOrderCancelStockAndStatusList = (data) =>
    SuperFetch.post('/order/cancel/management/list/update/complete/confirm', data);

  /**
   *  [취소 관리] 취소 완료 요청하기
   */
  completeOrderCancel = (data) => SuperFetch.post('/order/cancel/management/list/update/complete', data);

  /**
   *  [취소 관리] 취소 거부 -> 발송 처리하기
   */
  rejectOrderCancelDeliveryDispatch = (data) => SuperFetch.post('/order/cancel/management/list/update/delivery', data);

  /**
   *  [반품 관리] 반품 관리 리스트 요청하기
   */
  getOrderReturnManagementList = (data) => SuperFetch.post('/order/return/management/list', data);

  /**
   *  [반품 관리] 전체 리스트 엑셀 다운로드 요청하기
   */
  getOrderReturnManagementAllListExcelDownload = (data) =>
    SuperFetch.post('/order/return/management/list/excel/download', data);

  /**
   *  [반품 관리] 선택 리스트 엑셀 다운로드 요청하기
   */
  getOrderReturnManagementSelectedListExcelDownload = (data) =>
    SuperFetch.post('/order/return/management/list/excel/download/selected', data);

  /**
   *  [반품 관리] 반품 수거 완료 요청하기
   */
  completeCollectionOrderReturn = (data) => SuperFetch.post('/order/return/management/list/update/collect', data);

  /**
   *  [반품 관리] 반품 거부 요청하기
   */
  rejectOrderReturn = (data) => SuperFetch.post('/order/return/management/list/update/reject', data);

  /**
   *  [반품 관리] 반품 사유 수정하기 전 필요한 데이터 요청하기
   */
  getPreparationOrderReturnModifyReason = (data) =>
    SuperFetch.post('/order/return/management/list/update/reason/preparation', data);

  /**
   *  [반품 관리] 반품 사유 수정 요청하기
   */
  editOrderReturnReason = (data) => SuperFetch.post('/order/return/management/list/update/reason', data);

  /**
   *  [반품 관리] 반품 승인 요청하기
   */
  completeOrderReturn = (data) => SuperFetch.post('/order/return/management/list/update/complete', data);

  /**
   *  [반품 관리] 반품 -> 교환 요청하기
   */
  changeReturnToExchange = (data) => SuperFetch.post('/order/return/management/list/update/exchange', data);

  /**
   *  [반품 관리] 반품 사유, 반품 거부 사유 이미지 요청하기
   */
  getOrderReturnAttachment = (data) => SuperFetch.post('/order/return/management/detail/attachment', data);

  /**
   *  [교환 관리] 교환 관리 리스트 요청하기
   */
  getOrderExchangeManagementList = (data) => SuperFetch.post('/order/exchange/management/list', data);

  /**
   *  [교환 관리] 전체 리스트 엑셀 다운로드 요청하기
   */
  getOrderExchangeManagementAllListExcelDownload = (data) =>
    SuperFetch.post('/order/exchange/management/list/excel/download', data);

  /**
   *  [교환 관리] 선택 리스트 엑셀 다운로드 요청하기
   */
  getOrderExchangeManagementSelectedListExcelDownload = (data) =>
    SuperFetch.post('/order/exchange/management/list/excel/download/selected', data);

  /**
   *  [교환 관리] 교환 수거 완료 요청하기
   */
  completeCollectionOrderExchange = (data) => SuperFetch.post('/order/exchange/management/list/update/collect', data);

  /**
   *  [교환 관리] 교환 거부 요청하기
   */
  rejectOrderExchange = (data) => SuperFetch.post('/order/exchange/management/list/update/reject', data);

  /**
   *  [교환 관리] 교환 사유 수정하기 전 필요한 데이터 요청하기
   */
  getPreparationOrderExchangeEditReason = (data) =>
    SuperFetch.post('/order/exchange/management/list/update/reason/preparation', data);

  /**
   *  [교환 관리] 교환 사유 수정 요청하기
   */
  editOrderExchangeReason = (data) => SuperFetch.post('/order/exchange/management/list/update/reason', data);

  /**
   *  [교환 관리] 교환 재배송 송장 수정 요청하기
   */
  editOrderExchangeDeliveryInfo = (data) =>
    SuperFetch.post('/order/exchange/management/list/update/delivery/info', data);

  /**
   *  [교환 관리] 교환 승인 요청하기
   */
  completeOrderExchange = (data) => SuperFetch.post('/order/exchange/management/list/update/complete', data);

  /**
   *  [교환 관리] 교환 -> 반품 요청하기
   */
  changeExchangeToReturn = (data) => SuperFetch.post('/order/exchange/management/list/update/return', data);

  /**
   *  [교환 관리] 교환 사유, 교환 거부 사유 이미지 요청하기
   */
  getOrderExchangeAttachment = (data) => SuperFetch.post('/order/exchange/management/detail/attachment', data);

  /**
   *  [주문 상세] 주문 상세 요청하기
   */
  getOrderDetail = (data) => SuperFetch.post('/order/detail', data);

  /**
   *  [주문 상세] 주문 상태 되돌리기 요청하기
   */
  changeOrderItemStatus = (data) => SuperFetch.post('/order/update/status', data);
  /**
   *  [주문 상세] 주문 상태 되돌리기 요청하기 (구매 확정)
   */
  changeOrderConfirms = (data) => SuperFetchV2.delete('/order-confirms', { data });

  /**
   * [주문 상세] 구매 확정 상태에서 주문 상태 되돌리기 유효성 체크
   */
  getOrderConfirms = (orderItemId) => SuperFetchV2.get(`/order-confirms/${orderItemId}/cancelable`);

  /**
   *  [주문 반품 상세] 주문 반품 상세 요청하기
   */
  getOrderReturnDetail = (data) => SuperFetch.post('/order/return/detail', data);

  /**
   *  [주문 반품 상세] 주문 반품 환불 완료하기
   */
  setCompleteRefundOrderReturn = (data) => SuperFetch.post('/order/return/detail/complete', data);

  /**
   *  [주문상세] 교환 요청하기
   */
  orderExchangeRequest = (data) => SuperFetch.post('/order/exchange/request', data);

  /**
   *  [주문상세] 반품 요청하기
   */
  orderReturnRequest = (data) => SuperFetch.post('/order/return/request', data);

  /**
   *  [주문상세] 반품요청에 필요한 데이터 요청하기
   */
  getPreparationOrderReturnRequest = (data) => SuperFetch.post('/order/return/request/preparation', data);

  /**
   *  [주문상세] cs 메모 등록 요청하기
   */
  insertOrderItemCsMemoRequest = (data) => SuperFetch.post('/order/cs/insert', data);

  /**
   *  [주문상세] cs 메모 업데이트 요청하기
   */
  editOrderItemCsMemoRequest = (data) => SuperFetch.post('/order/cs/edit', data);

  /**
   *  [주문상세] 1:1 문의 리스트 요청하기
   */
  getOrderItemCsInquiryList = (data) => SuperFetch.post('/order/cs/inquiry/list', data);

  /**
   *  [주문상세] 1:1 문의 리스트 엑셀 다운로드 요청하기
   */
  getOrderItemCsInquiryListExcelDownload = (data) => SuperFetch.post('/order/cs/inquiry/list/excel/download', data);

  /**
   *  [주문상세] 상품 문의 리스트 요청하기
   */
  getOrderItemCsQnaList = (data) => SuperFetch.post('/order/cs/qna/list', data);

  /**
   *  [주문상세] 상품 문의 리스트 엑셀 다운로드 요청하기
   */
  getOrderItemCsQnaListExcelDownload = (data) => SuperFetch.post('/order/cs/qna/list/excel/download', data);
}

export default new OrderApi();
